import React from "react";
import { useNavigate } from "react-router-dom";
import "./payment_result.css";

export type ResultVariant = "success" | "error" | "pending" | "loading";

interface ResultAction {
  label: string;
  to: string;
}

interface PaymentResultProps {
  variant: ResultVariant;
  title: string;
  message: string;
  amount?: string | null;
  primary?: ResultAction;
  secondary?: ResultAction;
}

const CheckIcon = (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 13l4 4L19 7"
      stroke="#19b36b"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CrossIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" stroke="#e2554f" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const ClockIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="#e09a35" strokeWidth="2.5" />
    <path
      d="M12 7v5l3 2"
      stroke="#e09a35"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ICONS: Record<ResultVariant, React.ReactNode> = {
  success: CheckIcon,
  error: CrossIcon,
  pending: ClockIcon,
  loading: <div className="pr-spinner" />,
};

const PaymentResult: React.FC<PaymentResultProps> = ({
  variant,
  title,
  message,
  amount,
  primary,
  secondary,
}) => {
  const navigate = useNavigate();

  return (
    <div className="pr-page">
      <img src="/images/right-emails-logo.svg" className="pr-logo" alt="Right Emails" />

      <div className="pr-center">
        <div className="pr-card">
          <div className={`pr-hero pr-hero--${variant}`}>
            <div className="pr-badge">{ICONS[variant]}</div>
          </div>

          <div className="pr-body">
            <h2 className="pr-title">{title}</h2>
            <p className="pr-message">{message}</p>
            {amount && (
              <p className="pr-amount">
                Amount paid: <strong>{amount}</strong>
              </p>
            )}

            <div className="pr-divider" />

            {primary && (
              <button type="button" className="pr-btn" onClick={() => navigate(primary.to)}>
                {primary.label}
              </button>
            )}
            {secondary && (
              <button
                type="button"
                className="pr-btn pr-btn--ghost"
                onClick={() => navigate(secondary.to)}
              >
                {secondary.label}
              </button>
            )}
          </div>
        </div>

        <p className="pr-support">
          Get in touch with us at{" "}
          <a href="mailto:support@reachstream.com">support@reachstream.com</a> if you need any help.
        </p>
      </div>
    </div>
  );
};

export default PaymentResult;
